import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, Clock } from "lucide-react";
import { bk, nok, STATUS_LABEL } from "@/lib/booking";
import { useSeo, track } from "@/lib/seo";
import { Tracker } from "@/components/site/Tracker";

export default function Confirmed() {
  const [p] = useSearchParams();
  const [b, setB] = useState(null);
  const id = p.get("id");
  const sid = p.get("session_id");
  useSeo({ title: "Bestilling – Ask-Stokke Renhold", description: "Ordrebekreftelse", noindex: true });
  useEffect(() => {
    if (b?.payment_status === "paid" && !sessionStorage.getItem(`tracked-${id}`)) {
      sessionStorage.setItem(`tracked-${id}`, "1");
      track("purchase", { transaction_id: b.ref, value: b.price?.total, currency: "NOK" });
    }
  }, [b, id]);

  useEffect(() => {
    let n = 0;
    let timer;
    const poll = async () => {
      const r = await bk.status(id, sid).catch(() => null);
      setB(r);
      if (r && r.payment_status === "pending" && n++ < 15) timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [id, sid]);

  if (!b) return <div className="flex justify-center p-20"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  const ok = b.status === "bekreftet";
  return (
    <main className="mx-auto max-w-xl px-5 py-16 text-center" data-testid="confirmation-page">
      {ok ? <CheckCircle2 className="mx-auto h-14 w-14 text-[#2F5D50]" /> : <Clock className="mx-auto h-14 w-14 text-amber-500" />}
      <h1 className="mt-4 font-heading text-3xl font-extrabold" data-testid="confirmation-title">{ok ? "Bestillingen er bekreftet" : STATUS_LABEL[b.status]}</h1>
      <p className="mt-2 text-stone-600">Referanse <b data-testid="booking-ref">{b.ref}</b></p>
      <div className="mt-6"><Tracker status={b.status} /></div>
      <div className="mt-6 rounded-2xl border border-stone-200 bg-white p-5 text-left text-sm space-y-1">
        <div><b>{b.service_name}</b></div>
        <div>{b.date} kl. {b.start}–{b.end}</div>
        <div>{b.address}</div>
        <div className="pt-2 font-bold">{nok(b.price?.total)} · {b.payment_method === "card" ? (b.payment_status === "paid" ? "Betalt med kort" : "Venter på betaling") : "Faktura etter utført jobb"}</div>
      </div>
      <p className="mt-3 text-sm text-stone-500" data-testid="confirmation-email-status">{b.email_sent ? "Ordrebekreftelse er sendt på e-post." : b.payment_status === "pending" ? "Du får e-post når betalingen er registrert." : "Vi kunne ikke sende e-post akkurat nå – ta vare på referansen."}</p>
      {b.status === "venter_godkjenning" && <p className="mt-2 text-sm font-semibold text-amber-700">Bestillingen må godkjennes av oss. Du får beskjed på e-post.</p>}
      <Link to="/min-side" className="mt-6 inline-block rounded-full bg-[#2F5D50] px-6 py-3 font-bold text-white">Se mine bestillinger</Link>
    </main>
  );
}
